import React, {useMemo} from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const useStylesLayoutPublish = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
  },
  container: {
    paddingTop: theme.spacing(1),
  },
}));

LayoutPublish.propTypes = {
  small: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  itemRender: PropTypes.elementType.isRequired,
};

export default function LayoutPublish({small, data, itemRender}) {
  const classes = useStylesLayoutPublish({small});

  const sections = useMemo(() => Math.min(3, data.length), [data.length]);

  const item1 = data[0];
  const item2 = data[1];
  const item3 = data[2];

  if (sections === 1) {
    return (
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          {React.createElement(itemRender, {small, data: item1})}
        </Grid>
      </Grid>
    );
  }

  if (sections === 2) {
    return (
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12} md={6}>
          {React.createElement(itemRender, {small, data: item1})}
        </Grid>
        <Grid item xs={12} md={6}>
          {React.createElement(itemRender, {small, data: item2})}
        </Grid>
      </Grid>
    );
  }

  if (sections === 3) {
    return (
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12} md={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {React.createElement(itemRender, {small, data: item1})}
            </Grid>
            <Grid item xs={12}>
              {React.createElement(itemRender, {small, data: item2})}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={9}>
          {React.createElement(itemRender, {small, data: item3})}
        </Grid>
      </Grid>
    );
  }

  return <div className={classes.root}>No hay items</div>;
}
